import { ShapesTab } from "../ShapesTab";
import { MediaTab } from "../MediaTab";

export const ObjectsTab = ({
  previewWidth,
  previewHeight,
}: {
  previewWidth: number;
  previewHeight: number;
}) => {
  return (
    <>
      <ShapesTab previewWidth={previewWidth} previewHeight={previewHeight} />
      <MediaTab previewWidth={previewWidth} previewHeight={previewHeight} />
    </>
  );
};
